import React from 'react';
import SweetAlert from "react-bootstrap-sweetalert";

export default function ConfirmGeneralAlert(props) {

    const {
        onConfirm,
        onCancel,
        textConfirm,
        textTitle,
        textDesc
    } = props;

    return (
        <SweetAlert
            warning
            showCancel
            confirmBtnText={textConfirm}
            confirmBtnBsStyle="danger"
            title={<span className="mb-0 h4">{textTitle}</span>}
            onConfirm={onConfirm} // need to add loading indicator on confirm
            onCancel={onCancel}
            focusCancelBtn
        >
            {textDesc}
        </SweetAlert>
    );
}



